import axios from 'axios';
import { setActiveAccount } from 'utils/authSync';

const route = localStorage.getItem('baseUrl') || process.env.REACT_APP_API_URL;

export const getLoggedInUsers = () => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${route}/logined-users-list`, { withCredentials: true })
			.then(response => {
				const users = response?.data || [];

				if (users.length === 0) {
					clearAccounts();
				}

				console.debug('Fetched users:', users);

				const accountsMap = users.reduce((acc, account) => {
					acc[account.phoneNumber] = {
						id: account.id,
						role: account.role,
						fullName: account.fullName,
						phone: account.phoneNumber
					};
					return acc;
				}, {});

				localStorage.setItem('accounts', JSON.stringify(accountsMap));

				const activeAccount = JSON.parse(sessionStorage.getItem('activeAccount'));

				if (!users.some(account => account.id === activeAccount?.id)) {
					const defaultAccount = users[0]?.phoneNumber;

					setLastActiveAccount(defaultAccount);
					sessionStorage.setItem('activeAccount', JSON.stringify(users[0]));

					if (users.length) setActiveAccount(users[0]);
				}

				resolve(response);
			})
			.catch(err => {
				reject(err);
			});
	});
};

function clearAccounts() {
	try {
		localStorage.removeItem('accounts');
		localStorage.removeItem('xsrf-tokens');
		localStorage.removeItem('lastActiveAccount');

		sessionStorage.clear();
	} catch (error) {
		console.error('Error during clearing store:', error);
		throw error;
	}
}

function setLastActiveAccount(phone) {
	const accounts = JSON.parse(localStorage.getItem('accounts') || '{}');
	const selectedAccount = accounts[phone];

	if (selectedAccount) localStorage.setItem('lastActiveAccount', JSON.stringify(selectedAccount));
}
